import React, { Component } from 'react';
import { Route, Switch, Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import withAuth from '../WithAuth';
import Layout from '../Layout';
import AuthService from '../AuthService';
import constants from '../../config';
import UserSearch from './shared/UserSearch';
import UserDetailModal from './shared/UserDetailModal';
import ConfirmModal from './shared/ConfirmModal';
import AdminOverview from './AdminOverview';
import AdminTransactions from './AdminTransactions';
import AdminDisputes from './AdminDisputes';
import AdminReported from './AdminReported';
import AdminReportedUsers from './AdminReportedUsers';
import AdminPayouts from './AdminPayouts';
import AdminAuditLog from './AdminAuditLog';
import AdminUsers from './AdminUsers';
import AdminListings from './AdminListings';
import AdminCards from './AdminCards';
import AdminPaymentLedger from './AdminPaymentLedger';
import AdminSellerBalances from './AdminSellerBalances';
import AdminMessages from './AdminMessages';
import AdminAnalytics from './AdminAnalytics';
import AdminSiteSettings from './AdminSiteSettings';
import AdminNotificationLog from './AdminNotificationLog';
import AdminGames from './AdminGames';
import AdminStrikeAppeals from './AdminStrikeAppeals';
import AdminSealedProducts from './AdminSealedProducts';

var Auth = new AuthService();

var NAV_SECTIONS = [
  { label: null, items: [
    { key: 'overview', path: '/admin', label: 'Overview', icon: 'fa-tachometer', exact: true },
  ]},
  { label: 'Orders & Payments', items: [
    { key: 'transactions', path: '/admin/transactions', label: 'Transactions', icon: 'fa-exchange' },
    { key: 'disputes', path: '/admin/disputes', label: 'Disputes', icon: 'fa-exclamation-triangle' },
    { key: 'payouts', path: '/admin/payouts', label: 'Payouts', icon: 'fa-money' },
    { key: 'ledger', path: '/admin/ledger', label: 'Ledger', icon: 'fa-book', flag: 'flag_ledger' },
    { key: 'balances', path: '/admin/balances', label: 'Balances', icon: 'fa-balance-scale', flag: 'flag_balances' },
  ]},
  { label: 'Moderation', items: [
    { key: 'reported', path: '/admin/reported', label: 'Reported Listings', icon: 'fa-flag', exact: true },
    { key: 'reportedUsers', path: '/admin/reported-users', label: 'Reported Users', icon: 'fa-user-times' },
    { key: 'strikeAppeals', path: '/admin/strike-appeals', label: 'Strike Appeals', icon: 'fa-gavel' },
  ]},
  { label: 'Content', items: [
    { key: 'users', path: '/admin/users', label: 'Users', icon: 'fa-users' },
    { key: 'listings', path: '/admin/listings', label: 'Listings', icon: 'fa-tag' },
    { key: 'games', path: '/admin/games', label: 'Games', icon: 'fa-gamepad' },
    { key: 'cards', path: '/admin/cards', label: 'Card Catalog', icon: 'fa-clone' },
    { key: 'sealed', path: '/admin/sealed-products', label: 'Sealed Products', icon: 'fa-cube' },
  ]},
  { label: 'Communication', items: [
    { key: 'messages', path: '/admin/messages', label: 'Messages', icon: 'fa-envelope' },
    { key: 'notifications', path: '/admin/notifications', label: 'Email Log', icon: 'fa-bell' },
  ]},
  { label: 'System', items: [
    { key: 'analytics', path: '/admin/analytics', label: 'Analytics', icon: 'fa-bar-chart' },
    { key: 'settings', path: '/admin/settings', label: 'Settings', icon: 'fa-cog' },
    { key: 'audit', path: '/admin/audit-log', label: 'Audit Log', icon: 'fa-history' },
  ]},
];

// Flat list for mobile tab bar (legacy — kept for reference)
var NAV_ITEMS = [];
NAV_SECTIONS.forEach(function(section) { section.items.forEach(function(item) { NAV_ITEMS.push(item); }); });

// Mobile bottom tabs — each category opens a sheet except Overview (direct link)
var MOBILE_TABS = [
  { key: 'overview', icon: 'fa-tachometer', label: 'Overview', path: '/admin', exact: true },
  { key: 'orders', icon: 'fa-exchange', label: 'Orders', sectionIndex: 1 },
  { key: 'moderation', icon: 'fa-flag', label: 'Moderate', sectionIndex: 2 },
  { key: 'content', icon: 'fa-users', label: 'Content', sectionIndex: 3 },
  { key: 'communication', icon: 'fa-envelope', label: 'Comms', sectionIndex: 4 },
  { key: 'system', icon: 'fa-cog', label: 'System', sectionIndex: 5 },
];

class AdminLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarCollapsed: false,
      confirmModal: null,
      actionLoading: false,
      userModal: null,
      userDetail: null,
      userDetailLoading: false,
      userDetailTab: 'notes',
      noteText: '',
      strikeReason: '',
      strikeDetails: '',
      suspendReason: '',
      suspendDuration: '7',
      banReason: '',
      roleChangeValue: '',
      badgeCounts: { disputes: 0, reportedListings: 0, reportedUsers: 0, failedPayouts: 0 },
      featureFlags: {},
      refreshKey: 0,
      adminMessage: '',
      adminMessageSending: false,
      adminMessageSent: false,
      adminMessageConvoId: null,
      openSheet: null,
      sheetClosing: false,
    };
    this.openUserModal = this.openUserModal.bind(this);
    this.closeUserModal = this.closeUserModal.bind(this);
    this.fetchUserDetail = this.fetchUserDetail.bind(this);
    this.handleAddNote = this.handleAddNote.bind(this);
    this.handleAddStrike = this.handleAddStrike.bind(this);
    this.handleRemoveStrike = this.handleRemoveStrike.bind(this);
    this.handleSuspend = this.handleSuspend.bind(this);
    this.handleBan = this.handleBan.bind(this);
    this.handleUnsuspend = this.handleUnsuspend.bind(this);
    this.handleUnban = this.handleUnban.bind(this);
    this.handleChangeRole = this.handleChangeRole.bind(this);
    this.handleRelease = this.handleRelease.bind(this);
    this.handleRefund = this.handleRefund.bind(this);
    this.handleDismissReports = this.handleDismissReports.bind(this);
    this.handleDismissUserReports = this.handleDismissUserReports.bind(this);
    this.handleRemoveListing = this.handleRemoveListing.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleConfirmAction = this.handleConfirmAction.bind(this);
    this.fetchBadgeCounts = this.fetchBadgeCounts.bind(this);
    this.fetchFeatureFlags = this.fetchFeatureFlags.bind(this);
    this.handleSendAdminMessage = this.handleSendAdminMessage.bind(this);
    this.handleViewAdminConversation = this.handleViewAdminConversation.bind(this);
    this.toggleSheet = this.toggleSheet.bind(this);
    this.closeSheet = this.closeSheet.bind(this);
    this.sheetNavAndClose = this.sheetNavAndClose.bind(this);
  }

  toggleSheet(key) {
    if (this.state.openSheet === key) {
      this.closeSheet();
    } else {
      this.setState({ openSheet: key, sheetClosing: false });
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }
  }

  closeSheet() {
    var self = this;
    this.setState({ sheetClosing: true });
    setTimeout(function() {
      self.setState({ openSheet: null, sheetClosing: false });
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }, 280);
  }

  sheetNavAndClose(path) {
    this.props.history.push(path);
    this.closeSheet();
  }

  componentDidMount() {
    var userRole = (this.props.user && this.props.user.role) || 'user';
    if (userRole !== 'admin') {
      this.props.history.replace('/');
    }
    this.fetchBadgeCounts();
    this.fetchFeatureFlags();
    // Listen for theme changes to re-render dark mode styles
    var self = this;
    this._themeHandler = function () { self.forceUpdate(); };
    window.addEventListener('themeChanged', this._themeHandler);
  }

  componentWillUnmount() {
    if (this._themeHandler) {
      window.removeEventListener('themeChanged', this._themeHandler);
    }
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  fetchBadgeCounts() {
    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/badge-counts')
      .then(function(data) { self.setState({ badgeCounts: data }); })
      .catch(function() {});
  }

  fetchFeatureFlags() {
    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/site-config')
      .then(function(configs) {
        var flags = {};
        configs.forEach(function(c) {
          if (c.key.indexOf('flag_') === 0) {
            flags[c.key] = c.value && c.value.enabled;
          }
        });
        self.setState({ featureFlags: flags });
      })
      .catch(function() {});
  }

  // ─── User Modal ───
  openUserModal(userId) {
    this.setState({ userModal: userId, userDetail: null, userDetailLoading: true, userDetailTab: 'notes', noteText: '', strikeReason: '', strikeDetails: '' });
    this.fetchUserDetail(userId);
  }

  closeUserModal() {
    this.setState({ userModal: null, userDetail: null, adminMessage: '', adminMessageSending: false, adminMessageSent: false, adminMessageConvoId: null });
  }

  handleSendAdminMessage() {
    var self = this;
    var userId = this.state.userModal;
    var text = this.state.adminMessage.trim();
    if (!userId || !text) return;
    self.setState({ adminMessageSending: true });
    // Step 1: Create or get the admin conversation
    Auth.fetch(constants.DOMAIN + '/api/v1/messages', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: userId, adminChat: true }),
    })
      .then(function(data) {
        var convoId = data && data.conversation ? data.conversation._id : null;
        if (!convoId) throw new Error('No conversation returned');
        // Step 2: Send the message
        return Auth.fetch(constants.DOMAIN + '/api/v1/messages/' + convoId, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ text: text }),
        }).then(function() { return convoId; });
      })
      .then(function(convoId) {
        self.setState({ adminMessageSending: false, adminMessageSent: true, adminMessage: '', adminMessageConvoId: convoId });
        // Auto-reset success state after 3s
        setTimeout(function() {
          self.setState(function(prev) {
            if (prev.adminMessageSent) return { adminMessageSent: false };
            return null;
          });
        }, 3000);
      })
      .catch(function(err) {
        console.log('Failed to send admin message:', err);
        self.setState({ adminMessageSending: false });
        alert('Failed to send message: ' + (err.message || 'Unknown error'));
      });
  }

  handleViewAdminConversation() {
    var convoId = this.state.adminMessageConvoId;
    this.closeUserModal();
    if (convoId) {
      this.props.history.push('/admin/messages', { supportConvoId: convoId });
    } else {
      this.props.history.push('/admin/messages');
    }
  }

  fetchUserDetail(userId) {
    var self = this;
    self.setState({ userDetailLoading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/users/' + userId)
      .then(function(data) { self.setState({ userDetail: data, userDetailLoading: false }); })
      .catch(function(err) { console.log('Failed to fetch user detail:', err); self.setState({ userDetailLoading: false }); });
  }

  handleAddNote() {
    var self = this;
    var note = this.state.noteText.trim();
    if (!note) return;
    var userId = this.state.userModal;
    self.setState({ actionLoading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/users/' + userId + '/note', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note }),
    })
      .then(function(data) {
        var detail = Object.assign({}, self.state.userDetail);
        detail.user = Object.assign({}, detail.user, { adminNotes: data.adminNotes });
        self.setState({ userDetail: detail, noteText: '', actionLoading: false });
      })
      .catch(function(err) { self.setState({ actionLoading: false }); alert('Failed to add note: ' + (err.message || 'Unknown error')); });
  }

  handleAddStrike() {
    var self = this;
    var reason = this.state.strikeReason.trim();
    if (!reason) return;
    var userId = this.state.userModal;
    self.setState({ actionLoading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/users/' + userId + '/strike', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ reason: reason, details: self.state.strikeDetails.trim() }),
    })
      .then(function(data) {
        var detail = Object.assign({}, self.state.userDetail);
        detail.user = Object.assign({}, detail.user, { strikes: data.strikes });
        self.setState({ userDetail: detail, strikeReason: '', strikeDetails: '', actionLoading: false });
        if (data.autoSuspended) {
          alert('User has been automatically suspended for 7 days (3 strikes reached).');
          self.fetchUserDetail(userId);
        }
      })
      .catch(function(err) { self.setState({ actionLoading: false }); alert('Failed to add strike: ' + (err.message || 'Unknown error')); });
  }

  handleRemoveStrike(strikeId) {
    var self = this;
    var userId = this.state.userModal;
    self.setState({ actionLoading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/users/' + userId + '/strike/' + strikeId, {
      method: 'DELETE', headers: { 'Content-Type': 'application/json' },
    })
      .then(function(data) {
        var detail = Object.assign({}, self.state.userDetail);
        detail.user = Object.assign({}, detail.user, { strikes: data.strikes });
        self.setState({ userDetail: detail, actionLoading: false, confirmModal: null });
      })
      .catch(function(err) { self.setState({ actionLoading: false, confirmModal: null }); alert('Failed to remove strike: ' + (err.message || 'Unknown error')); });
  }

  handleSuspend(capturedUserId) {
    var self = this;
    var reason = this.state.suspendReason.trim();
    var duration = this.state.suspendDuration;
    if (!reason) return;
    var userId = capturedUserId || this.state.userModal;
    self.setState({ actionLoading: true, confirmModal: null });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/users/' + userId + '/suspend', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ reason: reason, duration: duration }),
    })
      .then(function() {
        self.setState({ suspendReason: '', suspendDuration: '7', actionLoading: false });
        self.fetchUserDetail(userId);
      })
      .catch(function(err) { self.setState({ actionLoading: false }); alert('Failed to suspend user: ' + (err.message || 'Unknown error')); });
  }

  handleBan(capturedUserId) {
    var self = this;
    var reason = this.state.banReason.trim();
    if (!reason) return;
    var userId = capturedUserId || this.state.userModal;
    self.setState({ actionLoading: true, confirmModal: null });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/users/' + userId + '/ban', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ reason: reason }),
    })
      .then(function() {
        self.setState({ banReason: '', actionLoading: false });
        self.fetchUserDetail(userId);
      })
      .catch(function(err) { self.setState({ actionLoading: false }); alert('Failed to ban user: ' + (err.message || 'Unknown error')); });
  }

  handleUnsuspend(capturedUserId) {
    var self = this;
    var userId = capturedUserId || this.state.userModal;
    self.setState({ actionLoading: true, confirmModal: null });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/users/' + userId + '/unsuspend', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({}),
    })
      .then(function() { self.setState({ actionLoading: false }); self.fetchUserDetail(userId); })
      .catch(function(err) { self.setState({ actionLoading: false }); alert('Failed to unsuspend user: ' + (err.message || 'Unknown error')); });
  }

  handleUnban(capturedUserId) {
    var self = this;
    var userId = capturedUserId || this.state.userModal;
    self.setState({ actionLoading: true, confirmModal: null });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/users/' + userId + '/unban', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({}),
    })
      .then(function() { self.setState({ actionLoading: false }); self.fetchUserDetail(userId); })
      .catch(function(err) { self.setState({ actionLoading: false }); alert('Failed to unban user: ' + (err.message || 'Unknown error')); });
  }

  handleChangeRole(capturedUserId, capturedRole) {
    var self = this;
    var userId = capturedUserId || this.state.userModal;
    var role = capturedRole || this.state.roleChangeValue;
    if (!role) return;
    self.setState({ actionLoading: true, confirmModal: null });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/users/' + userId + '/change-role', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ role: role }),
    })
      .then(function() {
        self.setState({ roleChangeValue: '', actionLoading: false });
        self.fetchUserDetail(userId);
      })
      .catch(function(err) { self.setState({ actionLoading: false }); alert('Failed to change role: ' + (err.message || 'Unknown error')); });
  }

  // ─── Transaction Actions ───
  handleRelease(txId) {
    var self = this;
    self.setState({ actionLoading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/transactions/' + txId + '/release', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
    })
      .then(function(data) {
        self.setState(function(prev) { return { actionLoading: false, confirmModal: null, refreshKey: prev.refreshKey + 1 }; });
        alert(data.message || 'Payout released');
      })
      .catch(function(err) { self.setState(function(prev) { return { actionLoading: false, confirmModal: null, refreshKey: prev.refreshKey + 1 }; }); alert('Release failed: ' + (err.message || 'Unknown error')); });
  }

  handleRefund(txId) {
    var self = this;
    self.setState({ actionLoading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/transactions/' + txId + '/refund', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
    })
      .then(function(data) {
        self.setState(function(prev) { return { actionLoading: false, confirmModal: null, refreshKey: prev.refreshKey + 1 }; });
        alert(data.message || 'Buyer refunded');
      })
      .catch(function(err) { self.setState(function(prev) { return { actionLoading: false, confirmModal: null, refreshKey: prev.refreshKey + 1 }; }); alert('Refund failed: ' + (err.message || 'Unknown error')); });
  }

  handleDismissReports(postId) {
    var self = this;
    self.setState({ actionLoading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/reported/' + postId + '/dismiss', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
    })
      .then(function() { self.setState(function(prev) { return { actionLoading: false, confirmModal: null, refreshKey: prev.refreshKey + 1 }; }); self.fetchBadgeCounts(); })
      .catch(function(err) { self.setState({ actionLoading: false, confirmModal: null }); alert('Dismiss failed: ' + (err.message || 'Unknown error')); });
  }

  handleDismissUserReports(userId) {
    var self = this;
    self.setState({ actionLoading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/reported-users/' + userId + '/dismiss', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
    })
      .then(function() { self.setState(function(prev) { return { actionLoading: false, confirmModal: null, refreshKey: prev.refreshKey + 1 }; }); self.fetchBadgeCounts(); })
      .catch(function(err) { self.setState({ actionLoading: false, confirmModal: null }); alert('Dismiss failed: ' + (err.message || 'Unknown error')); });
  }

  handleRemoveListing(postId) {
    var self = this;
    self.setState({ actionLoading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/reported/' + postId + '/remove', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
    })
      .then(function() { self.setState(function(prev) { return { actionLoading: false, confirmModal: null, refreshKey: prev.refreshKey + 1 }; }); self.fetchBadgeCounts(); })
      .catch(function(err) { self.setState({ actionLoading: false, confirmModal: null }); alert('Remove failed: ' + (err.message || 'Unknown error')); });
  }

  handleApproveAppeal(userId, strikeId) {
    var self = this;
    self.setState({ actionLoading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/strike-appeals/' + userId + '/' + strikeId + '/resolve', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ decision: 'approved', response: '' }),
    })
      .then(function() { self.setState(function(prev) { return { actionLoading: false, confirmModal: null, refreshKey: prev.refreshKey + 1 }; }); })
      .catch(function(err) { self.setState({ actionLoading: false, confirmModal: null }); alert('Approve failed: ' + (err.message || 'Unknown error')); });
  }

  handleDenyAppeal(userId, strikeId, response) {
    var self = this;
    self.setState({ actionLoading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/strike-appeals/' + userId + '/' + strikeId + '/resolve', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ decision: 'denied', response: response }),
    })
      .then(function() { self.setState(function(prev) { return { actionLoading: false, confirmModal: null, refreshKey: prev.refreshKey + 1 }; }); })
      .catch(function(err) { self.setState({ actionLoading: false, confirmModal: null }); alert('Deny failed: ' + (err.message || 'Unknown error')); });
  }

  // ─── Confirm Modal ───
  handleConfirm(modalConfig) {
    var self = this;
    var title, message, btnColor, btnIcon, onConfirm;

    if (modalConfig.type === 'release') {
      title = 'Release Payout';
      message = 'Release funds to the seller for "' + modalConfig.title + '"?';
      btnColor = '#10B981';
      btnIcon = 'fa-check';
      onConfirm = function() { self.handleRelease(modalConfig.txId); };
    } else if (modalConfig.type === 'refund') {
      title = 'Refund Buyer';
      message = 'Refund the buyer for "' + modalConfig.title + '"? This cannot be undone.';
      btnColor = '#EF4444';
      btnIcon = 'fa-undo';
      onConfirm = function() { self.handleRefund(modalConfig.txId); };
    } else if (modalConfig.type === 'dismiss') {
      title = 'Dismiss Reports';
      message = 'Clear all reports on "' + modalConfig.title + '"? The listing will remain active.';
      btnColor = '#6B7280';
      btnIcon = 'fa-times';
      onConfirm = function() { self.handleDismissReports(modalConfig.postId); };
    } else if (modalConfig.type === 'dismissUserReports') {
      title = 'Dismiss User Reports';
      message = 'Clear all reports on "' + modalConfig.userName + '"? No action will be taken.';
      btnColor = '#6B7280';
      btnIcon = 'fa-times';
      onConfirm = function() { self.handleDismissUserReports(modalConfig.userId); };
    } else if (modalConfig.type === 'remove') {
      title = 'Remove Listing';
      message = 'Permanently delete "' + modalConfig.title + '"? This will also add a strike to the seller\'s account.';
      btnColor = '#EF4444';
      btnIcon = 'fa-ban';
      onConfirm = function() { self.handleRemoveListing(modalConfig.postId); };
    } else if (modalConfig.type === 'removeStrike') {
      title = 'Remove Strike';
      message = 'Remove this strike from the user\'s account? This cannot be undone.';
      btnColor = '#EF4444';
      btnIcon = 'fa-trash';
      onConfirm = function() { self.handleRemoveStrike(modalConfig.strikeId); };
    } else if (modalConfig.type === 'suspendUser') {
      var suspendUserId = self.state.userModal;
      title = 'Suspend User';
      message = 'Suspend this user for ' + self.state.suspendDuration + ' day' + (self.state.suspendDuration !== '1' ? 's' : '') + '? They will be unable to log in and their shop will be closed.';
      btnColor = '#f59e0b';
      btnIcon = 'fa-pause-circle';
      onConfirm = function() { self.handleSuspend(suspendUserId); };
    } else if (modalConfig.type === 'banUser') {
      var banUserId = self.state.userModal;
      title = 'Ban User';
      message = 'Permanently ban this user? They will never be able to log in again unless manually unbanned.';
      btnColor = '#EF4444';
      btnIcon = 'fa-ban';
      onConfirm = function() { self.handleBan(banUserId); };
    } else if (modalConfig.type === 'unsuspendUser') {
      var unsuspendUserId = self.state.userModal;
      title = 'Lift Suspension';
      message = 'Lift this user\'s suspension early? Their account and shop will be restored.';
      btnColor = '#10B981';
      btnIcon = 'fa-check-circle';
      onConfirm = function() { self.handleUnsuspend(unsuspendUserId); };
    } else if (modalConfig.type === 'unbanUser') {
      var unbanUserId = self.state.userModal;
      title = 'Lift Ban';
      message = 'Lift this user\'s permanent ban? Their account and shop will be restored.';
      btnColor = '#10B981';
      btnIcon = 'fa-check-circle';
      onConfirm = function() { self.handleUnban(unbanUserId); };
    } else if (modalConfig.type === 'changeRole') {
      var changeRoleUserId = self.state.userModal;
      var newRole = self.state.roleChangeValue;
      var roleLabels = { user: 'User', admin: 'Admin' };
      title = 'Change User Role';
      message = 'Change this user\'s role to ' + (roleLabels[newRole] || newRole) + '?';
      btnColor = newRole === 'admin' ? '#D4A843' : '#6B7280';
      btnIcon = 'fa-users';
      onConfirm = function() { self.handleChangeRole(changeRoleUserId, newRole); };
    } else if (modalConfig.type === 'approveAppeal') {
      title = 'Approve Appeal';
      message = 'Approve ' + modalConfig.userName + '\'s appeal and remove the strike "' + modalConfig.strikeReason + '"?';
      btnColor = '#10B981';
      btnIcon = 'fa-check';
      onConfirm = function() { self.handleApproveAppeal(modalConfig.userId, modalConfig.strikeId); };
    } else if (modalConfig.type === 'denyAppeal') {
      title = 'Deny Appeal';
      message = 'Deny ' + modalConfig.userName + '\'s appeal for "' + modalConfig.strikeReason + '"? The strike will remain on their account.';
      btnColor = '#EF4444';
      btnIcon = 'fa-times';
      onConfirm = function() { self.handleDenyAppeal(modalConfig.userId, modalConfig.strikeId, modalConfig.denyResponse || ''); };
    } else if (modalConfig.title && modalConfig.onConfirm) {
      title = modalConfig.title;
      message = modalConfig.message;
      btnColor = modalConfig.btnColor;
      btnIcon = modalConfig.btnIcon;
      onConfirm = modalConfig.onConfirm;
    }

    this.setState({
      confirmModal: { title: title, message: message, btnColor: btnColor, btnIcon: btnIcon, onConfirm: onConfirm }
    });
  }

  handleConfirmAction() {
    var self = this;
    if (this.state.confirmModal && this.state.confirmModal.onConfirm) {
      var result = this.state.confirmModal.onConfirm();
      if (result && typeof result.then === 'function') {
        self.setState({ actionLoading: true, confirmModal: null });
        result
          .then(function() { self.setState({ actionLoading: false }); })
          .catch(function() { self.setState({ actionLoading: false }); });
      }
    }
  }

  render() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');
    var currentPath = this.props.location.pathname;

    return (
      <Layout>
        <Helmet><title>Admin Dashboard | Primal TCG</title></Helmet>
        <div className="tw-flex tw-min-h-screen">
          {/* Sidebar */}
          <aside
            className="admin-sidebar tw-flex-shrink-0 tw-hidden lg:tw-block tw-sticky tw-top-0 tw-self-start"
            style={{ width: this.state.sidebarCollapsed ? 64 : 220, height: '100vh', overflowY: 'auto', overflowX: 'hidden', backgroundColor: isDark ? '#1a1a1a' : '#fff', borderRight: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}
          >
            <div className="tw-pt-6 tw-pb-6">
              {/* Sidebar Header */}
              {!this.state.sidebarCollapsed && (
                <div className="tw-px-5 tw-mb-4">
                  <h2 className="tw-text-lg tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">Admin</h2>
                  <p className="tw-text-xs tw-text-[#999] tw-m-0 tw-mt-0.5">Platform Management</p>
                </div>
              )}

              {/* User Search in Sidebar */}
              {!this.state.sidebarCollapsed && (
                <div className="tw-px-3 tw-mb-4 tw-relative" style={{ zIndex: 10 }}>
                  <UserSearch onSelectUser={this.openUserModal} />
                </div>
              )}

              {/* Nav Items */}
              <nav className="tw-px-3">
                {NAV_SECTIONS.map(function(section, sIdx) {
                  return (
                    <div key={sIdx} className={sIdx > 0 ? 'tw-mt-4' : ''}>
                      {section.label && !self.state.sidebarCollapsed && (
                        <div className="tw-px-3 tw-mb-1">
                          <span className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider" style={{ color: '#999', letterSpacing: '0.05em' }}>{section.label}</span>
                        </div>
                      )}
                      {section.label && self.state.sidebarCollapsed && (
                        <div className="tw-mx-3 tw-mb-1" style={{ borderTop: '1px solid #e8e8e8', marginTop: '4px' }} />
                      )}
                      <div className="tw-space-y-0.5">
                        {section.items.filter(function(item) {
                          return !item.flag || self.state.featureFlags[item.flag];
                        }).map(function(item) {
                          var isActive = item.exact ? currentPath === item.path : currentPath.indexOf(item.path) === 0;
                          var badgeCount = 0;
                          if (item.key === 'disputes') badgeCount = self.state.badgeCounts.disputes || 0;
                          else if (item.key === 'reported') badgeCount = self.state.badgeCounts.reportedListings || 0;
                          else if (item.key === 'reportedUsers') badgeCount = self.state.badgeCounts.reportedUsers || 0;
                          else if (item.key === 'transactions') badgeCount = self.state.badgeCounts.failedPayouts || 0;
                          return (
                            <Link
                              key={item.key}
                              to={item.path}
                              className={'tw-flex tw-items-center tw-gap-3 tw-px-3 tw-py-2 tw-rounded-lg tw-text-sm tw-font-medium tw-transition-colors tw-no-underline tw-relative ' +
                                (isActive
                                  ? 'tw-text-[#1a1a1a] dark:tw-text-white'
                                  : 'tw-text-[#888] hover:tw-text-[#555] hover:tw-bg-[#f5f5f5] dark:hover:tw-bg-[#222]'
                                )
                              }
                              style={isActive ? { backgroundColor: 'rgba(212,168,67,0.1)' } : {}}
                            >
                              <i className={'fa ' + item.icon} style={isActive ? { color: '#D4A843' } : {}} />
                              {!self.state.sidebarCollapsed && (
                                <span className="tw-flex tw-items-center tw-justify-between tw-flex-1">
                                  <span>{item.label}</span>
                                  {badgeCount > 0 && (
                                    <span
                                      className="tw-text-xs tw-font-bold tw-rounded-full tw-text-white tw-flex tw-items-center tw-justify-center"
                                      style={{ backgroundColor: '#EF4444', minWidth: '20px', height: '20px', padding: '0 6px', fontSize: '11px' }}
                                    >
                                      {badgeCount}
                                    </span>
                                  )}
                                </span>
                              )}
                              {self.state.sidebarCollapsed && badgeCount > 0 && (
                                <span
                                  className="tw-absolute tw-text-xs tw-font-bold tw-rounded-full tw-text-white tw-flex tw-items-center tw-justify-center"
                                  style={{ backgroundColor: '#EF4444', minWidth: '16px', height: '16px', padding: '0 4px', fontSize: '10px', top: '2px', right: '2px' }}
                                >
                                  {badgeCount}
                                </span>
                              )}
                            </Link>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </nav>
            </div>
          </aside>

          {/* Mobile Tab Bar — 6 category tabs */}
          <div className="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-flex tw-z-50 lg:tw-hidden mobile-tab-bar" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', borderTop: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
            {MOBILE_TABS.map(function(tab) {
              // Determine if this tab's section has an active route
              var isActive = false;
              var sectionBadge = 0;
              if (tab.path) {
                // Direct link tab (Overview)
                isActive = tab.exact ? currentPath === tab.path : currentPath.indexOf(tab.path) === 0;
              } else if (tab.sectionIndex != null) {
                // Sheet tab — check if any item in the section matches
                var section = NAV_SECTIONS[tab.sectionIndex];
                if (section) {
                  section.items.forEach(function(item) {
                    if (item.flag && !self.state.featureFlags[item.flag]) return;
                    var itemActive = item.exact ? currentPath === item.path : currentPath.indexOf(item.path) === 0;
                    if (itemActive) isActive = true;
                    // Aggregate badge counts
                    if (item.key === 'disputes') sectionBadge += (self.state.badgeCounts.disputes || 0);
                    else if (item.key === 'reported') sectionBadge += (self.state.badgeCounts.reportedListings || 0);
                    else if (item.key === 'reportedUsers') sectionBadge += (self.state.badgeCounts.reportedUsers || 0);
                    else if (item.key === 'transactions') sectionBadge += (self.state.badgeCounts.failedPayouts || 0);
                  });
                }
              }
              var isSheetOpen = self.state.openSheet === tab.key;
              var tabColor = (isActive || isSheetOpen) ? '#D4A843' : (isDark ? '#888' : '#999');

              if (tab.path) {
                return (
                  <Link
                    key={tab.key}
                    to={tab.path}
                    className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-no-underline tw-relative tab-shimmer"
                    style={{ flex: 1, padding: '8px 0 6px', color: tabColor }}
                    onClick={function() { if (self.state.openSheet) self.closeSheet(); }}
                  >
                    <i className={'fa ' + tab.icon} style={{ fontSize: '18px' }} />
                    <span style={{ fontSize: '10px', marginTop: '2px', fontWeight: isActive ? 600 : 400 }}>{tab.label}</span>
                  </Link>
                );
              }

              return (
                <button
                  key={tab.key}
                  className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-relative tab-shimmer"
                  style={{ flex: 1, padding: '8px 0 6px', color: tabColor, background: 'none', border: 'none', cursor: 'pointer', WebkitTapHighlightColor: 'transparent' }}
                  onClick={function() { self.toggleSheet(tab.key); }}
                >
                  <i className={'fa ' + tab.icon} style={{ fontSize: '18px' }} />
                  <span style={{ fontSize: '10px', marginTop: '2px', fontWeight: (isActive || isSheetOpen) ? 600 : 400 }}>{tab.label}</span>
                  {sectionBadge > 0 && (
                    <span
                      className="tw-absolute tw-text-xs tw-font-bold tw-rounded-full tw-text-white tw-flex tw-items-center tw-justify-center"
                      style={{ backgroundColor: '#EF4444', minWidth: '16px', height: '16px', padding: '0 4px', fontSize: '10px', top: '2px', right: 'calc(50% - 18px)' }}
                    >
                      {sectionBadge}
                    </span>
                  )}
                </button>
              );
            })}
          </div>

          {/* Mobile Bottom Sheet */}
          {this.state.openSheet && (function() {
            // Find the section for this sheet
            var sheetTab = MOBILE_TABS.find(function(t) { return t.key === self.state.openSheet; });
            if (!sheetTab || sheetTab.sectionIndex == null) return null;
            var section = NAV_SECTIONS[sheetTab.sectionIndex];
            if (!section) return null;
            var items = section.items.filter(function(item) {
              return !item.flag || self.state.featureFlags[item.flag];
            });

            return (
              <div className="lg:tw-hidden" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 45 }}>
                {/* Backdrop */}
                <div
                  className={'sheet-backdrop' + (self.state.sheetClosing ? ' sheet-backdrop-closing' : '')}
                  style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', WebkitBackdropFilter: 'blur(4px)', backdropFilter: 'blur(4px)', touchAction: 'none' }}
                  onClick={function() { self.closeSheet(); }}
                  onTouchMove={function(e) { e.preventDefault(); }}
                />
                {/* Panel */}
                <div
                  className={'sheet-panel' + (self.state.sheetClosing ? ' sheet-panel-closing' : '')}
                  style={{
                    position: 'absolute', bottom: 0, left: 0, right: 0,
                    backgroundColor: isDark ? '#1a1a1a' : '#fff',
                    borderTopLeftRadius: '16px', borderTopRightRadius: '16px',
                    padding: '12px 16px 60px',
                    maxHeight: '70vh', overflowY: 'auto',
                  }}
                >
                  {/* Drag handle */}
                  <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '12px' }}>
                    <div style={{ width: '36px', height: '4px', borderRadius: '2px', backgroundColor: isDark ? '#444' : '#ddd' }} />
                  </div>
                  {/* Section title */}
                  <div style={{ padding: '0 4px', marginBottom: '8px' }}>
                    <span className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider" style={{ color: '#999', letterSpacing: '0.05em' }}>{section.label}</span>
                  </div>
                  {/* Nav items */}
                  {items.map(function(item) {
                    var itemActive = item.exact ? currentPath === item.path : currentPath.indexOf(item.path) === 0;
                    var badgeCount = 0;
                    if (item.key === 'disputes') badgeCount = self.state.badgeCounts.disputes || 0;
                    else if (item.key === 'reported') badgeCount = self.state.badgeCounts.reportedListings || 0;
                    else if (item.key === 'reportedUsers') badgeCount = self.state.badgeCounts.reportedUsers || 0;

                    return (
                      <button
                        key={item.key}
                        className="tw-w-full tw-flex tw-items-center tw-gap-3 tw-text-left tw-rounded-lg tw-transition-colors"
                        style={{
                          padding: '12px',
                          background: itemActive ? 'rgba(212,168,67,0.1)' : 'none',
                          border: 'none',
                          cursor: 'pointer',
                          color: itemActive ? (isDark ? '#fff' : '#1a1a1a') : (isDark ? '#ccc' : '#555'),
                          WebkitTapHighlightColor: 'transparent',
                        }}
                        onClick={function() { self.sheetNavAndClose(item.path); }}
                      >
                        <i className={'fa ' + item.icon} style={{ width: '20px', textAlign: 'center', fontSize: '16px', color: itemActive ? '#D4A843' : (isDark ? '#888' : '#999') }} />
                        <span className="tw-flex-1 tw-text-sm tw-font-medium">{item.label}</span>
                        {badgeCount > 0 && (
                          <span
                            className="tw-text-xs tw-font-bold tw-rounded-full tw-text-white tw-flex tw-items-center tw-justify-center"
                            style={{ backgroundColor: '#EF4444', minWidth: '20px', height: '20px', padding: '0 6px', fontSize: '11px' }}
                          >
                            {badgeCount}
                          </span>
                        )}
                        {itemActive && !badgeCount && (
                          <i className="fa fa-check" style={{ color: '#D4A843', fontSize: '14px' }} />
                        )}
                      </button>
                    );
                  })}
                </div>
              </div>
            );
          })()}

          {/* Main Content */}
          <main className="tw-flex-1 tw-min-w-0 tw-pb-20 lg:tw-pb-0">
            <div className="tw-max-w-7xl tw-mx-auto tw-px-4 tw-py-6">
              <Switch>
                <Route exact path="/admin" render={function(routeProps) {
                  return <AdminOverview {...routeProps} />;
                }} />
                <Route path="/admin/transactions" render={function(routeProps) {
                  return <AdminTransactions {...routeProps} onConfirm={self.handleConfirm} onOpenUserModal={self.openUserModal} refreshKey={self.state.refreshKey} />;
                }} />
                <Route path="/admin/disputes" render={function(routeProps) {
                  return <AdminDisputes {...routeProps} onConfirm={self.handleConfirm} onOpenUserModal={self.openUserModal} />;
                }} />
                <Route path="/admin/reported-users" render={function(routeProps) {
                  return <AdminReportedUsers {...routeProps} onConfirm={self.handleConfirm} onOpenUserModal={self.openUserModal} refreshKey={self.state.refreshKey} />;
                }} />
                <Route path="/admin/strike-appeals" render={function(routeProps) {
                  return <AdminStrikeAppeals {...routeProps} onConfirm={self.handleConfirm} onOpenUserModal={self.openUserModal} refreshKey={self.state.refreshKey} />;
                }} />
                <Route path="/admin/reported" render={function(routeProps) {
                  return <AdminReported {...routeProps} onConfirm={self.handleConfirm} onOpenUserModal={self.openUserModal} refreshKey={self.state.refreshKey} />;
                }} />
                <Route path="/admin/payouts" render={function(routeProps) {
                  return <AdminPayouts {...routeProps} onConfirm={self.handleConfirm} onOpenUserModal={self.openUserModal} refreshKey={self.state.refreshKey} />;
                }} />
                <Route path="/admin/ledger" render={function(routeProps) {
                  return <AdminPaymentLedger {...routeProps} onOpenUserModal={self.openUserModal} />;
                }} />
                <Route path="/admin/balances" render={function(routeProps) {
                  return <AdminSellerBalances {...routeProps} onConfirm={self.handleConfirm} onOpenUserModal={self.openUserModal} />;
                }} />
                <Route path="/admin/users" render={function(routeProps) {
                  return <AdminUsers {...routeProps} onOpenUserModal={self.openUserModal} />;
                }} />
                <Route path="/admin/listings" render={function(routeProps) {
                  return <AdminListings {...routeProps} onConfirm={self.handleConfirm} onOpenUserModal={self.openUserModal} />;
                }} />
                <Route path="/admin/games" render={function(routeProps) {
                  return <AdminGames {...routeProps} />;
                }} />
                <Route path="/admin/sealed-products" render={function(routeProps) {
                  return <AdminSealedProducts {...routeProps} />;
                }} />
                <Route path="/admin/cards" render={function(routeProps) {
                  return <AdminCards {...routeProps} />;
                }} />
                <Route path="/admin/messages" render={function(routeProps) {
                  return <AdminMessages {...routeProps} onConfirm={self.handleConfirm} onOpenUserModal={self.openUserModal} />;
                }} />
                <Route path="/admin/analytics" render={function(routeProps) {
                  return <AdminAnalytics {...routeProps} onOpenUserModal={self.openUserModal} />;
                }} />
                <Route path="/admin/settings" render={function(routeProps) {
                  return <AdminSiteSettings {...routeProps} />;
                }} />
                <Route path="/admin/notifications" render={function(routeProps) {
                  return <AdminNotificationLog {...routeProps} onOpenUserModal={self.openUserModal} />;
                }} />
                <Route path="/admin/audit-log" render={function(routeProps) {
                  return <AdminAuditLog {...routeProps} />;
                }} />
              </Switch>
            </div>
          </main>
        </div>

        {/* Shared Modals */}
        <ConfirmModal
          modal={this.state.confirmModal}
          loading={this.state.actionLoading}
          onConfirm={this.handleConfirmAction}
          onCancel={function() { self.setState({ confirmModal: null }); }}
        />

        <UserDetailModal
          userId={this.state.userModal}
          loading={this.state.userDetailLoading}
          detail={this.state.userDetail}
          tab={this.state.userDetailTab}
          noteText={this.state.noteText}
          strikeReason={this.state.strikeReason}
          strikeDetails={this.state.strikeDetails}
          suspendReason={this.state.suspendReason}
          suspendDuration={this.state.suspendDuration}
          banReason={this.state.banReason}
          roleChangeValue={this.state.roleChangeValue}
          actionLoading={this.state.actionLoading}
          onClose={this.closeUserModal}
          onTabChange={function(t) { self.setState({ userDetailTab: t }); }}
          onNoteChange={function(v) { self.setState({ noteText: v }); }}
          onStrikeReasonChange={function(v) { self.setState({ strikeReason: v }); }}
          onStrikeDetailsChange={function(v) { self.setState({ strikeDetails: v }); }}
          onSuspendReasonChange={function(v) { self.setState({ suspendReason: v }); }}
          onSuspendDurationChange={function(v) { self.setState({ suspendDuration: v }); }}
          onBanReasonChange={function(v) { self.setState({ banReason: v }); }}
          onRoleChangeValueChange={function(v) { self.setState({ roleChangeValue: v }); }}
          onChangeRole={function() { self.handleConfirm({ type: 'changeRole' }); }}
          onAddNote={this.handleAddNote}
          onAddStrike={this.handleAddStrike}
          onRemoveStrike={function(strikeId) { self.handleConfirm({ type: 'removeStrike', strikeId: strikeId }); }}
          onSuspend={function() { self.handleConfirm({ type: 'suspendUser' }); }}
          onBan={function() { self.handleConfirm({ type: 'banUser' }); }}
          onUnsuspend={function() { self.handleConfirm({ type: 'unsuspendUser' }); }}
          onUnban={function() { self.handleConfirm({ type: 'unbanUser' }); }}
          adminMessage={this.state.adminMessage}
          adminMessageSending={this.state.adminMessageSending}
          adminMessageSent={this.state.adminMessageSent}
          adminMessageConvoId={this.state.adminMessageConvoId}
          onAdminMessageChange={function(v) { self.setState({ adminMessage: v }); }}
          onSendAdminMessage={this.handleSendAdminMessage}
          onViewConversation={this.handleViewAdminConversation}
        />
      </Layout>
    );
  }
}

export default withAuth(AdminLayout);
